import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import 'primeflex/themes/primeone-light.css'
import 'primeflex/primeflex.css'

import Toaster from "vue-toastification"
import "vue-toastification/dist/index.css"

import '@/assets/css/main.css'
import '@/assets/css/responsive.css'
import '@/assets/icons/fontawesome-web/css/all.css'

import Tag from 'primevue/tag'
import Image from 'primevue/image'
import Paginator from 'primevue/paginator'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TieredMenu from 'primevue/tieredmenu'
import Menu from 'primevue/menu'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Select from 'primevue/select'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import ToggleSwitch from 'primevue/toggleswitch'
import MultiSelect from 'primevue/multiselect'
import Tabs from 'primevue/tabs'
import Tab from 'primevue/tab'
import TabList from 'primevue/tablist'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'
import Password from 'primevue/password'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import Checkbox from 'primevue/checkbox'
import Message from 'primevue/message'
import InputNumber from 'primevue/inputnumber'
import Avatar from 'primevue/avatar'
import DatePicker from 'primevue/datepicker'
import FileUpload from 'primevue/fileupload'
import Textarea from 'primevue/textarea'
import Fieldset from 'primevue/fieldset'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice'
import Divider from 'primevue/divider'
import Accordion from 'primevue/accordion'
import AccordionPanel from 'primevue/accordionpanel'
import AccordionHeader from 'primevue/accordionheader'
import AccordionContent from 'primevue/accordioncontent'
import Badge from 'primevue/badge'
import InputOtp from 'primevue/inputotp'
import Chart from 'primevue/chart'
import Card from 'primevue/card'
import Chip from 'primevue/chip'
import Tree from 'primevue/tree'
import Skeleton from 'primevue/skeleton'
import Dialog from 'primevue/dialog'
import Drawer from 'primevue/drawer'
import SplitButton from 'primevue/splitbutton'
import Galleria from 'primevue/galleria'
import Carousel from 'primevue/carousel'
import PanelMenu from 'primevue/panelmenu'
import Listbox from 'primevue/listbox'
import AutoComplete from 'primevue/autocomplete'
import Timeline from 'primevue/timeline'

const app = createApp(App)

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#FFF3E6",
            100: "#FFE0BF",
            200: "#FFC68A",
            300: "#FFAD55",
            400: "#FF9C2E",
            500: "#FF9015", // base
            600: "#E67F12",
            700: "#CC6F10",
            800: "#B35F0D",
            900: "#804509"
        },

        colorScheme: {
            light: {
                formField: {
                    hoverBorderColor: "{primary.color}"
                },
                surface: {
                    contentBackground: "{surface.50}"
                }
            },
            dark: {
                formField: {
                    hoverBorderColor: "{secondary.color}"
                },
                surface: {
                    contentBackground: "{surface.800}"
                }
            }
        }
    },
    components: {
        // button: {
        //     labelFontWeight: 'bold'
        // },
        datatable: {
            borderColor: 'var(--surface-600) !important'
        },
        fileupload: {
            background: "#0000 !important",
        },
        tieredmenu: {
            background: "inherit !important",
            border: {
                color: "none"
            },
            item: {
                gap: "1rem"
            },
            list: {
                gap: "1.5rem"
            },
            submenu: {
                background: "#FFF",
            }
        },
        fieldset: {
            legend: {
                font: {
                    weight: 'medium'
                }
            }
        },
        accordion: {
            panelBorderColor: 'var(--surface-500) !important'
        },
        panelmenu: {
            panel: 'border: none !important'
        }
    }
})

app.use(router)
app.use(store)
app.use(ConfirmationService)
app.use(Toaster)

app.component('Timeline', Timeline)
app.component('Tag', Tag)
app.component('AutoComplete', AutoComplete)
app.component('Listbox', Listbox)
app.component('Image', Image)
app.component('Paginator', Paginator)
app.component('Dialog', Dialog)
app.component('Skeleton', Skeleton)
app.component('InputNumber', InputNumber)
app.component('Loading', Loading)
app.component('Button', Button)
app.component('InputText', InputText)
app.component('TieredMenu', TieredMenu)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Menu', Menu)
app.component('Select', Select)
app.component('IconField', IconField)
app.component('InputIcon', InputIcon)
app.component('ToggleSwitch', ToggleSwitch)
app.component('MultiSelect', MultiSelect)
app.component('Tab', Tab)
app.component('Tabs', Tabs)
app.component('TabList', TabList)
app.component('TabPanels', TabPanels)
app.component('TabPanel', TabPanel)
app.component('Password', Password)
app.component('InputGroup', InputGroup)
app.component('InputGroupAddon', InputGroupAddon)
app.component('Checkbox', Checkbox)
app.component('Message', Message)
app.component('Avatar', Avatar)
app.component('DatePicker', DatePicker)
app.component('FileUpload', FileUpload)
app.component('Textarea', Textarea)
app.component('Fieldset', Fieldset)
app.component('ConfirmDialog', ConfirmDialog)
app.component('Divider', Divider)
app.component('Accordion', Accordion)
app.component('AccordionPanel', AccordionPanel)
app.component('AccordionHeader', AccordionHeader)
app.component('AccordionContent', AccordionContent)
app.component('Badge', Badge)
app.component('InputOtp', InputOtp)
app.component('Chart', Chart)
app.component('Card', Card)
app.component('Chip', Chip)
app.component('Tree', Tree)
app.component('Drawer', Drawer)
app.component('SplitButton', SplitButton)
app.component('Galleria', Galleria)
app.component('Carousel', Carousel)
app.component('PanelMenu', PanelMenu)

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: 'system'
        }
    }
})


app.mount('#app')